module.exports = __webpack_public_path__ + "img/03_img.ae928066.png";